import { hsl } from 'polished';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { Physicals } from '../../canvas/entities/Physicals';
import { Sticky } from './Sticky';

export const createSticky = defineCommand(
    'createSticky',
    'Create: Sticky',
    (r) => {
        Physicals.createAtCameraPosition(r, Sticky, nc => {
            const hu = Math.random() * 360;
            nc.width = 150;
            nc.height = 150;
            nc.background = hsl(hu * 360, .8, .61);
        });
    },
);

// export const stickyClearOwner = defineCommand(
//     'stickyClearOwner',
//     'Sticky: Clear Owner',
//     (cc, [targets]: [string[]?]) => {

//         const subjects = resolveSubjects(cc, targets);
//         if (!subjects.length) return;

//         const objects = cc.resolve(ObjectManager);
//         objects.update(() => {
//             for (const s of subjects) {
//                 s.userId = null;
//             }
//         });

//     }
// );
